import React from 'react';
import { MessageBar, MessageBarType, MessageBarButton, initializeIcons} from 'office-ui-fabric-react';
initializeIcons();


// export default class ErrorMessage extends React.Component {
//   render() {
//     let debug = null;
//     if (this.props.debug) {
//       debug = <pre ><code>{this.props.debug}</code></pre>;
//     }
//     return (
//       <>
//         <p className="mb-3">{this.props.message}</p>
//         {debug}
//       </>
//     );
//   }
// }

export const ErrorMessage =({message, debug})=>{

return (
  <>
    <MessageBar
      isMultiline={false}
      messageBarType={MessageBarType.error}
      isMultiline={false}
      dismissButtonAriaLabel="Close" 
      truncated={true}
      overflowButtonAriaLabel="See more" 
      dismissButtonAriaLabel="Close"         
    >
        {message}
        {debug}
    </MessageBar>
  </>
);
}

